<template>
  <b-row>
    <b-col lg="12" xl="12" class="mb-5">
      <dashboard-box :title="$t('new_offer.new_offer_text')">
        <template v-slot:preview>
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row>
              <b-col xl="6">
                <b-form-group id="input-group-3" :label="$t('new_offer.offer_type')" label-for="input-3">
                  <b-form-select
                      class="form-control form-control-solid"
                      v-model="form.offer_type"
                      :options="offer_types"
                      @change="changeIt($event,'offer_types')"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col xl="6">
                <b-form-group
                    :label="$t('new_offer.project_name_')"
                    :description="$t('new_offer.project_name_description')"
                >
                  <b-form-input
                      v-model="form.name"
                      type="text"
                      class="form-control form-control-solid"
                      required
                      :placeholder="$t('new_offer.project_name')"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <template v-if="form_status">
              <b-row>
                <b-col xl="4">
                  <b-form-group id="input-group-3" :label="$t('new_offer.offer_owner_')" label-for="input-3">
                    <b-form-select
                        class="form-control form-control-solid"
                        v-model="form.owner"
                        :options="owners"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col xl="4">
                  <b-form-group
                      label="Anket Türü"
                  >
                    <b-form-select
                        class="form-control form-control-solid"
                        v-model="campaign_form.survey_type"
                        :options="campaign.survey_types"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col xl="4">
                  <b-form-group :label="$t('new_offer.customer_type')">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.customer_type"
                          :options="customer_types">
                      </b-form-select>
                      <b-input-group-append>
                        <b-button v-b-modal.customer_types variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="customer_types" hide-footer :title="$t('new_offer.customer_type')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_customer_type variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_customer_type" title="Yeni Müşteri Tipi Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Müşteri Grubu Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Müşteri grubu adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_customer_type" title="Son Müşteri" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Müşteri Grubu Adı">
                                <b-form-input
                                    type="text"
                                    value="Son Müşteri"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Müşteri grubu adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.customer_type"
                            :fields="report.customer_type_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-6" :label="$t('new_offer.contact_')" label-for="input-5">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.contact_id"
                          :options="contacts"
                      ></b-form-select>
                      <b-input-group-append>
                        <b-button v-b-modal.contacts variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="contacts" hide-footer :title="$t('new_offer.contact')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_contact variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_contact" title="Yeni Kontak Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group :label="$t('new_offer.customer_')" label-for="input-group-4" id="input-group-4">
                                <b-form-select
                                    id="input-group-4"
                                    class="form-control form-control-solid"
                                    v-model="form.customer_id"
                                    :options="customers"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Ünvan">
                                <b-form-input
                                    class="form-control form-control-solid"
                                    type="text"
                                    placeholder="Ünvan giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Ad Soyad">
                                <b-form-input
                                    class="form-control form-control-solid"
                                    type="text"
                                    placeholder="Ad Soyad giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="E-Posta">
                                <b-form-input
                                    class="form-control form-control-solid"
                                    type="text"
                                    placeholder="E-Posta giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Telefon">
                                <b-form-input
                                    class="form-control form-control-solid"
                                    type="text"
                                    placeholder="Telefon numarası giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_contact" title="Kaya Petek" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group :label="$t('new_offer.customer_')" label-for="input-group-4" id="input-group-4">
                                <b-form-select
                                    id="input-group-4"
                                    class="form-control form-control-solid"
                                    v-model="form.customer_id"
                                    :options="customers"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Ünvan">
                                <b-form-input
                                    class="form-control form-control-solid"
                                    type="text"
                                    value="Müşavir"
                                    placeholder="Ünvan giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Ad Soyad">
                                <b-form-input
                                    value="Kaya Petek"
                                    class="form-control form-control-solid"
                                    type="text"
                                    placeholder="Ad Soyad giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="E-Posta">
                                <b-form-input
                                    value="kaya_petek@gmail.com"
                                    class="form-control form-control-solid"
                                    type="text"
                                    placeholder="E-Posta giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Telefon">
                                <b-form-input
                                    value="0555 555 55 55"
                                    class="form-control form-control-solid"
                                    type="text"
                                    placeholder="Telefon numarası giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.contacts"
                            :fields="report.contact_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group :label="$t('new_offer.customer_')" label-for="input-group-4" id="input-group-4">
                    <b-input-group>
                      <b-form-select
                          id="input-group-4"
                          class="form-control form-control-solid"
                          v-model="form.customer_id"
                          :options="customers"
                      ></b-form-select>

                      <b-input-group-append>
                        <b-button v-b-modal.customers variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>

                  <b-modal size="xl" id="customers" hide-footer title="Müşteriler">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_customer variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_customer" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="6">
                              <b-form-group label="Ad Soyad">
                                <b-form-input
                                    class="form-control form-control-solid"
                                    type="text"
                                    placeholder="Ad Soyad giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Ürün Tipi">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    v-model="form.product_type"
                                    :options="product_types"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Varsayılan Para Birimi">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    :value="$t('general.select')"
                                    :options="[$t('general.select'),'TL','EUR','USD']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Vergi Muafiyeti">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    :value="$t('general.select')"
                                    :options="[$t('general.select'),'Muaf','Muaf Değil']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Fatura Ayrıntıları">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    :value="$t('general.select')"
                                    :options="[$t('general.select'),'Dahil','Hariç']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_customer" title="Ali Sayar" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="6">
                              <b-form-group label="Ad Soyad">
                                <b-form-input
                                    class="form-control form-control-solid"
                                    type="text"
                                    value="Ali Sayar"
                                    placeholder="Ad Soyad giriniz."
                                >
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Ürün Tipi">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    v-model="form.product_type"
                                    :options="product_types"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Varsayılan Para Birimi">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    value="TL"
                                    :options="[$t('general.select'),'TL','EUR','USD']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Vergi Muafiyeti">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    value="Muaf"
                                    :options="[$t('general.select'),'Muaf','Muaf Değil']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Fatura Ayrıntıları">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    value="Hariç"
                                    :options="[$t('general.select'),'Dahil','Hariç']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.customers"
                            :fields="report.customer_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-7" :label="$t('new_offer.sector_')" label-for="input-3">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.sector_id"
                          :options="sectors"
                      ></b-form-select>
                      <b-input-group-append>
                        <b-button v-b-modal.sectors variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="sectors" hide-footer :title="$t('new_offer.sector')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_sector variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_sector" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Sektör Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Sektör adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_sector" title="Gıda" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Sektör Adı">
                                <b-form-input
                                    type="text"
                                    value="Gıda"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Sektör adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.sectors"
                            :fields="report.sector_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-4" :label="$t('new_offer.country_')" label-for="input-3">
                    <b-form-select
                        class="form-control form-control-solid"
                        v-model="form.country_id"
                        :options="countries"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-7" :label="$t('new_offer.project_type')" label-for="input-3">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.project_type"
                          :options="project_types"
                      ></b-form-select>
                      <b-input-group-append>
                        <b-button v-b-modal.project_types variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="project_types" hide-footer :title="$t('new_offer.project_type')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_project_type variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_project_type" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Proje Tipi">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Proje tipi giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_project_type" title="Online Panel" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Proje Tipi">
                                <b-form-input
                                    type="text"
                                    value="Online Panel"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Proje tipi giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.project_types"
                            :fields="report.project_type_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group :label="$t('new_offer.research_')" label-for="input-3">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.research_id"
                          :options="researches"
                      ></b-form-select>
                      <b-input-group-append>
                        <b-button v-b-modal.researches variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="researches" hide-footer :title="$t('new_offer.researchs')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_research_type variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_research_type" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Araştırma Tipi Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Araştırma Tipi adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_research_type" title="Gündem Araştırması" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Araştırma Tipi Adı">
                                <b-form-input
                                    type="text"
                                    value="Gündem Araştırması"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Araştırma tipi adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.research_types"
                            :fields="report.research_type_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-7" :label="$t('new_offer.things_to_do')" label-for="input-3">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.things_to_do"
                          :options="things_to_do"
                      ></b-form-select>
                      <b-input-group-append>
                        <b-button v-b-modal.things_to_dos variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="things_to_dos" hide-footer :title="$t('new_offer.things_to_do')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_things_to_do variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_things_to_do" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Yapılacak Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Yapılacak adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_things_to_do" title="Saha" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Yapılacak Adı">
                                <b-form-input
                                    type="text"
                                    value="Saha"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Yapılacak adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.things_to_dos"
                            :fields="report.things_to_do_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-7" :label="$t('new_offer.product_type')" label-for="input-3">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.product_type"
                          :options="product_types"
                      ></b-form-select>
                      <b-input-group-append>
                        <b-button v-b-modal.product_types variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="product_types" hide-footer :title="$t('new_offer.product_type')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_product_type variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_product_type" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Ürün Tipi Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Ürün tipi adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_product_type" title="Kantitatif Tracking" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="12">
                              <b-form-group label="Ürün Tipi Adı">
                                <b-form-input
                                    type="text"
                                    value="Kantitatif Tracking"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Ürün tipi adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.product_types"
                            :fields="report.product_type_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-7" :label="$t('new_offer.wave')" label-for="input-3">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.wave"
                          :options="waves"
                      ></b-form-select>

                      <b-input-group-prepend is-text>
                        <b-form-checkbox switch class="mr-n2">
                          <span class="sr-only"></span>
                        </b-form-checkbox>
                        {{$t('new_offer.show_offer')}}
                      </b-input-group-prepend>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-7" :label="$t('new_offer.project_status')" label-for="input-3">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.project_status"
                          :options="project_status"
                      ></b-form-select>

                      <b-input-group-append>
                        <b-button v-b-modal.project_status variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="project_status" hide-footer :title="$t('new_offer.project_status')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_project_status variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_project_status" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="6">
                              <b-form-group label="Durum Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Durum adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Durum Kısa Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Durum için kısa bir ad giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Grup Seçiniz">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    :value="$t('general.select')"
                                    :options="[$t('general.select'),'Teklif Kartı', 'Wave']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_project_status" title="Onaylandı" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="6">
                              <b-form-group label="Durum Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    value="Onaylandı"
                                    placeholder="Durum adı giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Durum Kısa Adı">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    value="CNF"
                                    placeholder="Durum için kısa bir ad giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Grup Seçiniz">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    value="Teklif Kartı"
                                    :options="[$t('general.select'),'Teklif Kartı', 'Wave']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.project_status"
                            :fields="report.project_status_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </b-col>
                <b-col xl="4">
                  <b-form-group id="input-group-7" :label="$t('new_offer.potential_for_sale')" label-for="input-3">
                    <b-input-group>
                      <template v-slot:append>
                        <b-input-group-text class="form-control form-control-solid"><strong>%</strong></b-input-group-text>
                      </template>
                      <b-input
                          class="form-control form-control-solid"
                          :placeholder="$t('new_offer.potential_for_sale')"
                          type="number"
                      ></b-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="separator separator-dashed mb-6"></div>
              <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('new_offer.information') }}</h3>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group :label="$t('new_offer.order_date_')" label-for="input-2">
                    <b-form-input
                        class="form-control form-control-solid"
                        v-model="form.date"
                        type="date"
                        required
                        :placeholder="$t('new_offer.order_date')"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group id="ir_form_group" :label="$t('new_offer.ir')" label-for="input-3">
                    <b-input-group>
                      <template v-slot:append>
                        <b-input-group-text class="form-control form-control-solid"><strong>%</strong></b-input-group-text>
                      </template>
                      <b-input
                          v-model="form.ir"
                          class="form-control form-control-solid"
                          :placeholder="$t('new_offer.ir')"
                          type="number"
                      ></b-input>
                    </b-input-group>
                  </b-form-group>

                  <b-tooltip target="ir_form_group">
                    Kolay > %80 <hr> %80 > Orta > %40 <hr> 39% < Zor
                  </b-tooltip>
                </div>
                <div class="col-md-4">
                  <b-form-group :label="$t('new_offer.loi')">
                    <b-input-group>
                      <template v-slot:append>
                        <b-input-group-text class="form-control form-control-solid"><strong>dk</strong></b-input-group-text>
                      </template>
                      <b-form-input
                          class="form-control form-control-solid"
                          :placeholder="$t('new_offer.loi')"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
              <div class="separator separator-dashed mb-6"></div>
              <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('new_offer.field_information') }}</h3>
              <div class="row">
                <div class="clearfix"></div>
                <div class="col-md-4">
                  <b-form-group :label="$t('new_offer.currency_')" label-for="input-3">
                    <b-input-group>
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="form.currency_id"
                          :options="currencies"
                      ></b-form-select>
                      <b-input-group-append>
                        <b-button v-b-modal.currencies variant="secondary"><i class="fas fa-cog"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-modal size="xl" id="currencies" hide-footer :title="$t('new_offer.currencies')">
                    <b-row>
                      <b-col xl="12" class="text-right">
                        <b-button size="sm" v-b-modal.add_currency variant="primary" class="mb-3"><i class="fas fa-plus"></i> {{$t('general.add')}}</b-button>
                        <b-modal size="lg" id="add_currency" title="Yeni Ekle" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="6">
                              <b-form-group label="Para Birimi">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Para birimi giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Para Birimi Kısa Kodu">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    placeholder="Para birimi için kısa bir kod giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Çevirme Gerekiyor Mu ?">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    :value="$t('general.select')"
                                    :options="[$t('general.select'),'Evet', 'Hayır']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                        <b-modal size="lg" id="edit_currency" title="Onaylandı" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')">
                          <b-row>
                            <b-col xl="6">
                              <b-form-group label="Para Birimi">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    value="Türk Lirası"
                                    placeholder="Para birimi giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Para Birimi Kısa Kodu">
                                <b-form-input
                                    type="text"
                                    class="form-control form-control-solid"
                                    required
                                    value="TRY"
                                    placeholder="Para birimi için kısa bir kod giriniz."
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col xl="6">
                              <b-form-group label="Çevirme Gerekiyor Mu ?">
                                <b-form-select
                                    class="form-control form-control-solid"
                                    value="Evet"
                                    :options="[$t('general.select'),'Evet', 'Hayır']"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-modal>
                      </b-col>
                      <b-col xl="12">
                        <data-table
                            :items="table.currencies"
                            :fields="report.currency_fields"
                            :paginate="report.paginate"
                            page.sync="3"
                            perPage.sync="10"
                        ></data-table>
                      </b-col>
                    </b-row>
                  </b-modal>
                </div>
                <div class="col-md-4">
                  <b-form-group :label="$t('new_offer.exchange_rate_')" label-for="input-3">
                    <b-input-group>
                      <b-form-input
                          class="form-control form-control-solid"
                          v-model="form.exchange_rate"
                          type="text"
                          required
                          disabled
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button variant="secondary"><i class="fa-eye fa"></i>{{ $t('new_offer.learn') }}</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group id="sample_description" :label="$t('new_offer.sample')" label-for="input-1">
                    <b-form-input
                        v-model="form.sample"
                        type="text"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.sample')"
                    ></b-form-input>
                  </b-form-group>
                  <b-tooltip target="sample_description">
                    Wave başına örneklem sayısı
                  </b-tooltip>
                </div>
                <div class="col-md-4">
                  <b-form-group :label="$t('new_offer.unit_price')" label-for="input-1">
                    <b-form-input
                        v-model="form.unit_price"
                        type="text"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.unit_price')"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group id="total_price_description" :label="$t('new_offer.total_price')" label-for="input-1">
                    <b-form-input
                        v-model="form.total_price"
                        type="text"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.total_price')"
                        disabled
                    ></b-form-input>
                  </b-form-group>

                  <b-tooltip target="total_price_description">
                    <strong>Örneklem</strong> x <strong>Birim Fiyatı</strong>
                  </b-tooltip>
                </div>
                <div class="col-md-4">
                  <b-form-group id="general_price_description" :label="$t('new_offer.general_price')" label-for="input-1">
                    <b-form-input
                        v-model="form.general_price"
                        type="text"
                        class="form-control form-control-solid"
                        :placeholder="$t('new_offer.general_price')"
                        disabled
                    ></b-form-input>
                  </b-form-group>

                  <b-tooltip target="general_price_description">
                    <strong>Toplam Fiyat</strong> x <strong>Wave Sayısı</strong>
                  </b-tooltip>
                </div>
              </div>

              <hr class="mb-5">
              <div class="row">
                <div class="col-md-12 mb-5">
                  <b-form-textarea class="form-control form-control-solid" id="textarea-rows" :placeholder="$t('new_offer.note')" rows="8"></b-form-textarea>
                </div>
              </div>
            </template>
            <!-- Campaign -->
            <b-row v-if="form_status == false">
              <b-col lg="6" sm="12">
                <b-form-group label="Kampanya Adı">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Kampanya Adı"
                      v-model="campaign_form.name"
                      @input="changeItName($event)"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                    label="Kampanya Durumu"
                >
                  <b-form-select
                      class="form-control form-control-solid"
                      v-model="campaign_form.campaign_status"
                      :options="campaign.campaign_status"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Buton Yazısı">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Buton Yazısı"
                      value=""
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Anasayfa Başlığı">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Anasayfa Başlığı"
                      value=""
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Detay Sayfası Başlığı">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Detay Sayfası Başlığı"
                      value=""
                  ></b-form-input>
                </b-form-group>
                <b-row>
                  <b-col lg="12">
                    <h3 class="font-size-lg text-dark font-weight-bold mb-6">Kampanya Görseli</h3>
                    <div class="separator separator-dashed my-6"></div>
                    <b-form-group label="940x300px" label-for="file-default" label-cols-sm="2">
                      <b-form-file id="file-default" placeholder="Görsel seçiniz" browse-text="Seçim yap"></b-form-file>
                    </b-form-group>

                    <img style="width:100%;border-radius: 8px;" src="http://cdn.napolyon.com/napolyon/profilgorev/PB_kisiselbilgiler_750x330.png" alt="">
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="6" sm="12">
                <b-form-group label="Kampanya URL">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Kampanya URL"
                      v-model="campaign_form.slug"
                      value=""
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                    label="Anket Türü"
                >
                  <b-form-select
                      class="form-control form-control-solid"
                      v-model="campaign_form.survey_type"
                      :options="campaign.survey_types"
                  ></b-form-select>
                </b-form-group>
                <b-form-group
                    label="Bitiş Bantı"
                >
                  <b-form-select
                      class="form-control form-control-solid"
                      v-model="campaign_form.end_tape"
                      :options="campaign.end_tapes"
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Buton URL">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="text"
                      name="name"
                      placeholder="Buton URL"
                      value=""
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Anasayfa Açıklaması">
                  <b-form-textarea
                      class="form-control form-control-solid"
                      name="name"
                      placeholder="Anasayfa Açıklaması"
                      value=""
                  ></b-form-textarea>
                </b-form-group>
                <b-row>
                  <div class="col-lg-6">
                    <b-form-group label="Başlangıç Tarihi" label-for="input-2">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="date"
                          required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="Bitiş Tarihi" label-for="input-2">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="date"
                          required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group>
                      <b-form-checkbox
                          id="checkbox-1"
                          name="checkbox-1"
                          value="accepted"
                          unchecked-value="not_accepted"
                          class="mb-5"
                      >
                        Kazananlar Kampanyası Var
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group>
                      <b-form-checkbox
                          aria-label="checkbox-12"
                          id="checkbox-12"
                          name="checkbox-12"
                          value="accepted"
                          unchecked-value="not_accepted"
                          class="mb-5"
                      >
                        İlişkili Anket Var
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="Wave">
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="campaign_form.wave"
                          :options="campaign.waves"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="İlişkili Anket">
                      <b-form-select
                          class="form-control form-control-solid"
                          v-model="campaign_form.survey"
                          :options="campaign.surveys"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group>
                      <b-form-checkbox
                          aria-label="checkbox-13"
                          id="checkbox-13"
                          name="checkbox-13"
                          value="accepted"
                          unchecked-value="not_accepted"
                      >
                        CRM Mini Anket
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group>
                      <b-form-checkbox
                          aria-label="checkbox-14"
                          id="checkbox-14"
                          name="checkbox-14"
                          value="accepted"
                          unchecked-value="not_accepted"
                      >
                        Mobilde Göster
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group>
                      <b-form-checkbox
                          aria-label="checkbox-14"
                          id="checkbox-14"
                          name="showDorinsight"
                          value="accepted"
                          unchecked-value="not_accepted"
                      >
                        Napolyon'da Göster
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                </b-row>
              </b-col>
              <b-col lg="12" sm="12" class="mt-10">
                <template>
                  <RichTextArea></RichTextArea>
                </template>
              </b-col>

              <b-col lg="12" sm="12" class="mt-10">
                <b-tabs content-class="mt-3">
                  <b-tab title="TAB 1" active>
                    <b-form-group label="Başlık">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          placeholder="Kampanya Adı"
                          value=""
                      ></b-form-input>
                    </b-form-group>
                    <RichTextArea></RichTextArea>

                  </b-tab>
                  <b-tab title="TAB 2">
                    <b-form-group label="Başlık">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          placeholder="Kampanya Adı"
                          value=""
                      ></b-form-input>
                    </b-form-group>
                    <RichTextArea></RichTextArea>
                  </b-tab>
                  <b-tab title="TAB 3">
                    <b-form-group label="Başlık">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          placeholder="Kampanya Adı"
                          value=""
                      ></b-form-input>
                    </b-form-group>
                    <RichTextArea></RichTextArea>
                  </b-tab>
                  <b-tab title="TAB 4">
                    <b-form-group label="Başlık">
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          placeholder="Kampanya Adı"
                          value=""
                      ></b-form-input>
                    </b-form-group>
                    <RichTextArea></RichTextArea>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <!-- Campaign -->
            <!-- Message Share Campaign -->
            <b-row v-if="form_status == false" >
              <b-col lg="12" class="mt-7 mb-7">
                <div class="h6 mb-3 table-vertical-center">
                  <b-form-checkbox
                      id="message-share"
                      v-model="message_share_status"
                      name="message_share_status"
                      :unchecked-value="false"
                      class="d-inline-flex pt-4px"
                      size="md"
                  >
                  </b-form-checkbox>
                  <label for="message-share">{{ $t('campaigns.message_share_campaign') }}</label>
                </div>
                <div class="separator separator-dashed"></div>
              </b-col>
              <b-row v-if="message_share_status">
                <b-col lg="6">
                  <b-form-group label="Kampanya Sayfası">
                    <b-input-group>
                      <b-form-input
                          class="form-control form-control-solid"
                          type="text"
                          name="name"
                          disabled
                          value="/Mesaj-Paylas/napolyon-cmpcampaign-template"
                          placeholder="Kampanya Adı"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary">Kopyala</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-row>
                    <b-col lg="6">
                      <b-form-group label="Tanıtım Başlığı">
                        <b-form-input
                            class="form-control form-control-solid"
                            type="text"
                            placeholder="Tanıtım Başlığı"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6">
                      <b-form-group
                          label="Maksimum Katılım Hakkı"
                      >
                        <b-form-select
                            class="form-control form-control-solid"
                            v-model="message_campaign_form.max_participation"
                            :options="message_campaign.max_participations"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="12">
                      <b-form-group label="Maksimum Katılım SQL">
                        <b-form-textarea
                            class="form-control form-control-solid"
                            placeholder="SQL Kodu"
                            value=""
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6">
                      <b-form-checkbox
                          value="accepted"
                          unchecked-value="not_accepted"
                      >
                        Resimli?
                      </b-form-checkbox>
                    </b-col>
                    <b-col lg="6">
                      <b-form-checkbox
                          value="accepted"
                          unchecked-value="not_accepted"
                      >
                        Onay Gerekli?
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6">
                  <RichTextArea></RichTextArea>
                </b-col>
              </b-row>
            </b-row>
            <!-- Message Share Campaign -->
          </b-form>
        </template>
        <template v-slot:foot>
          <b-button type="submit" variant="primary" class="fa-pull-right"><i class="fa fa-save"></i> {{ $t('general.save') }}</b-button>
        </template>
      </dashboard-box>
    </b-col>
  </b-row>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import RichTextArea from "@/view/pages/vue-bootstrap/RichTextArea";

export default {
name: "CreateOffer",
  components: { DataTable, DashboardBox, RichTextArea },
  methods: {
    changeIt(data,input) {
      if (input == "offer_types"){
        if (data == "Araştırma"){
          this.form_status = true;
        }
        if (data == "CRM"){
          this.form_status = false;
        }
      }
      if (input == "message_share_status"){
        if (data === true){
          this.message_share_status = true;
        }else{
          this.message_share_status = false;
        }
      }
    },
    HideModal(){
      window.alert('Tebrikler!');
    },
    onSubmit(evt) {
      evt.preventDefault();
      Swal.fire({
        title: "",
        text: "Teklif kartı onay için gönderilmiştir.",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText: "Tamam"
      });
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    changeItName(){
      this.campaign_form.slug = _.kebabCase(this.campaign_form.name);
    }
  },
  data() {
    return {
      form: {
        name: '',
        owner: null,
        customer_id: null,
        contact_id: null,
        country_id: null,
        sector_id: null,
        project_type: null,
        product_type: null,
        things_to_do : null,
        research_id: null,
        currency_id: null,
        exchange_rate: '1.0000',
        new_customer_name : '',
        wave : null,
        ir : null,
        loi : null,
        sample : null,
        unit_price : null,
        total_price : null,
        general_price : null,
        ops_cost : null,
        project_status : null,
        potential_for_sale : null,
        customer_type : null,
        offer_type : 'CRM',
      },
      campaign_form : {
        name: '',
        campaign_status : null,
        end_tape : null,
        survey : null,
        wave : null,
        slug: "",
        survey_type : null,
      },
      campaign : {
        campaign_status: [{ text: this.$t('general.select'), value: null } , 'Test Modu','Aktif', 'Pasif'],
        end_tapes: [{ text: this.$t('general.select'), value: null } , 'Mavi','Sarı', 'Kırmızı'],
        surveys : [{ text: this.$t('general.select'), value: null } , 'Limonist (P12929)','Deneme (P12928)', 'Test (P12927)'],
        waves: [{ text: this.$t('general.select'), value: null } , '1','2', '3','4','5','6'],
        slug: '',
        survey_types : [
            { text: this.$t('general.select'), value: null },
          'Base Link\'li Anket',
          'Havuz Link\'li Anket',
          'Müşteri Listesine Anket (SPSS)',
          'SSI Web Anketi',
          'Müşteri Listesine Anket (SSI)'
        ]
      },
      message_campaign_form : {
        selected_campaign: null,
        max_participation: null,
      },
      message_campaign : {
        campaigns: [{ text: this.$t('general.select'), value: null } , 'Napolyon CMP Campaign Template', 'Caps', 'Bilgi Yarışması Eylül 2015 Kazananlar', '100.000 Nap Puan Ekim', 'Eşleştirme Eylül Kazananlar', 'Ekim Reeder'],
        max_participations: [{ text: this.$t('general.select'), value: null } , 1,2,3,4,5,6,7,8],
      },
      form_status : false,
      message_share_status : false,
      owners: [{ text: this.$t('general.select'), value: null }, 'Ali Duran', 'Kaya Petek', 'Ayşe Güldirek', 'Aysel Budak'],
      customers: [{ text: this.$t('general.select'), value: null }, 'BSH', 'BTA', 'Carat', 'Caretta İletişim', 'CarrefourSA', 'Coco Cola', 'Collective', 'Çanakçılar Seramik', 'D&R','Çiçek Sepeti'],
      contacts: [{ text: this.$t('general.select'), value: null }, 'Colin Butcher', 'Kaya Petek', 'Ayşe Güldirek', 'Aysel Budak'],
      countries: [{ text: this.$t('general.select'), value: null }, 'Türkiye', 'Almanya', 'Çin', 'Hindistan'],
      sectors: [{ text: this.$t('general.select'), value: null }, 'Gıda', 'Bilişim & Teknoloji', 'Giyim'],
      researches: [{ text: this.$t('general.select'), value: null }, 'Fiyatlama / Conjoint Araştırmaları', 'Gündem Araştırması', 'Marka Bilinirliği Araştırmaları', 'Marka Değeri / Marka İmaj / Konumlandırma', 'Memnuniyet Araştırmaları', 'Napolyon CRM Mini Anket', 'Reklam - Kampanya Testi'],
      currencies: [{ text: this.$t('general.select'), value: null }, 'TRY', 'USD', 'EUR'],
      project_types : [{ text: this.$t('general.select'), value: null }, 'Online Panel','F2F','CATI','Kalitatif','CAWI','Exit Survey'],
      product_types : [
          { text: this.$t('general.select'), value: null },
        'Kantitatif Araştırma Fiyat Analizleri',
        'Kantitatif Tracking',
        'Kantitatif Araştırma Memnuniyet-NPS Araştırmaları',
        'Kantitatif Araştırma Gizli Müşteri Araştırmaları',
        'Kantitatif Araştırma Shopper',
        'Kantitatif Araştırma Profil ve Segmentasyon Araştırmaları',
        'Kantitatif Araştırma Reklam Ön Testi Araştırmaları (Pre-Test)',
        'Kantitatif Araştırma Reklam Sonrası  Testi Araştırmaları(Post-Test)',
        'Kantitatif Araştırma Sosyal Araştırmalar',
        'Kantitatif Araştırma Tutum ve Davranış Araştırmaları - U&A',
        'Kantitatif Araştırma Konsept Ürün Fikir Testi',
        'Kantitatif Araştırma Konsept Fikir Testi',
        'Kantitatif Araştırma Ambalaj Testi Araştırmaları',
        'Kantitatif Araştırma İsim Testi Araştırmaları',
        'Kantitatif Araştırma Tat Testi',
        'Data Teslimi',
        'Script + Data Teslimi',
        'Script + Data Teslimi + Tablo',
        'Kalitatif Tracking',
        'Kalitatif Araştırma Memnuniyet-NPS Araştırmaları',
        'Kalitatif Araştırma Gizli Müşteri Araştırmaları',
        'Kalitatif Araştırma Shopper',
        'Kalitatif Araştırma Profil ve Segmentasyon Araştırmaları',
        'Kalitatif Araştırma Reklam Ön Testi Araştırmaları (Pre-Test)',
        'Kalitatif Araştırma Reklam Sonrası  Testi Araştırmaları(Post-Test)',
        'Kalitatif Araştırma Sosyal Araştırmalar',
        'Kalitatif Araştırma Tutum ve Davranış Araştırmaları',
        'Kalitatif Araştırma Konsept Ürün Fikir Testi',
        'Kalitatif Araştırma Konsept Fikir Testi',
        'Kalitatif Araştırma Ambalaj Testi Araştırmaları',
        'Kalitatif Araştırma İsim Testi Araştırmaları',
        'Kalitatif Araştırma Tat Testi',
        'Sampling - Yurtiçi',
        'Sampling - Yurtdışı',
        'Omnibus',
        'Modelleme',
        'Kurumsal İtibar',
        'Diğer',
        'Kalitatif Adhoc'
      ],
      show: true,
      things_to_do : [{ text: this.$t('general.select'), value: null },
        'Saha',
        'Saha + Script',
        'Script + Data Teslim',
        'Script + Tablo / Data Teslim',
        'Saha + Script + Tablo / Data Teslim',
        'Soru Formu + Script + Saha + Tablolama / Data Teslim',
        'Soru Formu + Script + Saha + Tablolama + Rapor',
        'Soru Formu + Script + Saha + Tablo / Data Teslim',
        'Soru Formu + Script + Saha + Tablolama + Rapor + Data Teslim',
        'Soru Formu + Script + Saha + Tablolama + Rapor + Sunum',
        'Script + Tablo + Rapor',
        'Denek Temini',
        'Sor Formu + Saha + Analiz Raporlama',
      ],
      waves:  [{text : this.$t('general.select'), value : null}, '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      ir_options:  [{text : this.$t('general.select'), value : null}, 'Kolay > %80', '%80 > Orta > %40', '39% < Zor'],
      loi_options:  [{text : this.$t('general.select'), value : null}, '5 dk', '10 dk', '15 dk', '20 dk', '25 dk', '30 dk'],
      project_status:  [{text : this.$t('general.select'), value : null}, 'Aktif','Onaylandı', 'Red', 'Faturası Kesildi'],
      potential_for_sale_options:  [{text : this.$t('general.select'), value : null}, '90%','50%', '25%'],
      customer_types:  [{text : this.$t('general.select'), value : null}, 'Son Müşteri','Araştırma Şirketi', 'Basın', 'Danışmanlık Şirketi', 'Halkla İlişkiler ve İletişim', 'Medya Ajansı', 'Panel Şirketi', 'Pazarlama ve Reklamcılık', 'Reklam Ajansı'],
      offer_types:  ['Araştırma','CRM'],
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        customer_type_fields: [
          {key: 'name', label: 'Müşteri Tipi', sortable: false},
          {key: 'customer_type_actions', label: 'İşlem', sortable: false},
        ],
        contact_fields: [
          {key: 'name', label: 'Ad Soyad', sortable: false},
          {key: 'contact_actions', label: 'İşlem', sortable: false},
        ],
        sector_fields: [
          {key: 'name', label: 'Sektör Adı', sortable: false},
          {key: 'sector_actions', label: 'İşlem', sortable: false},
        ],
        project_type_fields: [
          {key: 'name', label: 'Proje Tipi', sortable: false},
          {key: 'project_type_actions', label: 'İşlem', sortable: false},
        ],
        research_type_fields: [
          {key: 'name', label: 'Araştırma Tipi', sortable: false},
          {key: 'research_type_actions', label: 'İşlem', sortable: false},
        ],
        things_to_do_fields: [
          {key: 'name', label: 'Araştırma Tipi', sortable: false},
          {key: 'things_to_do_actions', label: 'İşlem', sortable: false},
        ],
        product_type_fields: [
          {key: 'name', label: 'Ürün Tipi', sortable: false},
          {key: 'product_type_actions', label: 'İşlem', sortable: false},
        ],
        customer_fields: [
          {key: 'name', label: 'Ad Soyad', sortable: false},
          {key: 'customer_actions', label: 'İşlem', sortable: false},
        ],
        project_status_fields : [
          {key: 'name', label: 'Durum Adı', sortable: false},
          {key: 'shortcode', label: 'Kısa Kod', sortable: false},
          {key: 'project_status_actions', label: 'İşlem', sortable: false},
        ],
        currency_fields : [
          {key: 'name', label: 'Para Birimi', sortable: false},
          {key: 'shortcode', label: 'Kısa Kod', sortable: false},
          {key: 'currency_actions', label: 'İşlem', sortable: false},
        ]
      },
      table : {
        customer_type : [
          {'name' : 'Son Müşteri'},
          {'name' : 'Araştırma Şirketi'},
          {'name' : 'Basın'},
          {'name' : 'Danışmanlık Şirketi'},
          {'name' : 'Halkla İlişkiler ve İletişim'},
          {'name' : 'Medya Ajansı'},
          {'name' : 'Panel Şirketi'},
          {'name' : 'Pazarlama ve Reklamcılık'},
          {'name' : 'Reklam Ajansı'}
          ],
        contacts : [
          {'name' : 'Ali Sayar'},
          {'name' : 'Kaya Petek'},
          {'name' : 'Ayşegül Duran'},
          {'name' : 'Ertuğrul Duman'},
        ],
        sectors : [
          {'name' : 'Gıda'},
          {'name' : 'Bilişim & Teknoloji'},
          {'name' : 'Giyim'},
        ],
        project_types : [
          {'name' : 'Online Panel'},
          {'name' : 'F2F'},
          {'name' : 'CATI'},
          {'name' : 'Kalitatif'},
          {'name' : 'CAWI'},
          {'name' : 'Exit Survey'},
        ],
        research_types : [
          {'name' : 'Fiyatlama / Conjoint Araştırmaları'},
          {'name' : 'Gündem Araştırması'},
          {'name' : 'Marka Bilinirliği Araştırması'},
          {'name' : 'Reklam - Kampanya Testi'},
        ],
        things_to_dos : [
          {'name' : 'Saha'},
          {'name' : 'Saha + Script'},
          {'name' : 'Denek Temini'},
          {'name' : 'Script + Tablo + Rapor'},
        ],
        product_types : [
          {'name' : 'Kantitatif Tracking'},
          {'name' : 'Kantitatif Araştırma Fiyat Analizleri'},
          {'name' : 'Data Teslimi'},
          {'name' : 'Script + Data Teslimi'},
          {'name' : 'Omnibus'},
          {'name' : 'Modelleme'},
        ],
        customers : [
          {'name' : 'Ali Sayar'},
          {'name' : 'Kaya Petek'},
          {'name' : 'Ayşegül Duran'},
          {'name' : 'Ertuğrul Duman'},
        ],
        project_status : [
          {'name' : 'Onaylandı' , 'shortcode' : 'CNF'},
          {'name' : 'Aktif' , 'shortcode' : 'ACT'},
          {'name' : 'Red' , 'shortcode' : 'DSC'},
          {'name' : 'Faturası Kesildi' , 'shortcode' : 'DLV'},
        ],
        currencies : [
          {'name' : 'Türk Lirası' , 'shortcode' : 'TRY'},
          {'name' : 'Amerikan Doları' , 'shortcode' : 'USD'},
          {'name' : 'Euro' , 'shortcode' : 'EUR'},
        ],
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_1'), route: "alert" },
      { title: this.$t('new_offer.new_offer_text') }
    ]);
  }
}
</script>

<style scoped>
.editor__content .ProseMirror:focus {
  outline: none !important;
}
.pt-4px{
  padding-top: 4px;
}
.btn.btn-secondary i{
  font-size: 12px;
}
</style>
